import React from 'react';
import {
  FilterPanel,
  DefaultPanel,
  FilterSection,
  Panel,
  PanelLink,
} from '../../../shared/components/PanelFilters';
import Styles from './styles';
import { Switch } from 'antd';
import { AccountFilterPanel } from '../../../shared/components/AccountFilterPanel';
import { ParticipantsTypeFilter } from '../../../shared/components/ParticipantsTypeFilter';
import { usePastMeetings } from '../../../meetings/past-meetings/past-meetings.hook';
import { MeetingTypeFilter } from '../MeetingTypeFilter';

const { Label, Option } = Styles;

export const PastMeetingsFilter: React.FC = () => {
  const {
    updateAccounts,
    meetingType,
    showMineOnly,
    showReadyOnly,
    showOnlyUnmappedAccounts,
    mType,
    updateAccountsFiltered,
    meetingTypeChanged,
    changeShowMineOnly,
    changeShowReadyOnly,
    changeShowOnlyUnmappedAccounts,
    resetFilters,
    updateMType,
  } = usePastMeetings();

  const count =
    updateAccounts.length +
    (showMineOnly ? 1 : 0) +
    (showReadyOnly ? 1 : 0) +
    (showOnlyUnmappedAccounts ? 1 : 0) +
    (['internal', 'external'].includes(meetingType) ? 1 : 0) +
    (mType ? 1 : 0);
  const isClearDisabled = count === 0;

  const onClear = () => {
    resetFilters();
  };

  return (
    <FilterPanel count={count}>
      <DefaultPanel clear={{ disabled: isClearDisabled, onClear }}>
        <FilterSection title="General">
          <Option>
            <Label>Show mine only</Label>
            <Switch
              checked={showMineOnly}
              onChange={value => changeShowMineOnly(value)}
              size="small"
            />
          </Option>

          <Option>
            <Label>Show ready only</Label>
            <Switch
              checked={showReadyOnly}
              onChange={value => changeShowReadyOnly(value)}
              size="small"
            />
          </Option>

          <Option>
            <Label>Show only unmapped accounts</Label>
            <Switch
              checked={showOnlyUnmappedAccounts}
              onChange={value => changeShowOnlyUnmappedAccounts(value)}
              size="small"
            />
          </Option>
        </FilterSection>

        <FilterSection title="Accounts">
          <PanelLink
            label="Accounts"
            panelId="accounts"
            value={`Accounts (${updateAccounts.length})`}
          />
        </FilterSection>

        <FilterSection title="Meeting types">
          <MeetingTypeFilter initialType={mType} onChange={updateMType} />
        </FilterSection>

        <FilterSection title="Invitee scope">
          <ParticipantsTypeFilter
            value={meetingType}
            onParticipantTypeChanged={meetingTypeChanged}
          />
        </FilterSection>
      </DefaultPanel>

      <Panel panelId="accounts" title="Accounts" clear={{ disabled: isClearDisabled, onClear }}>
        <AccountFilterPanel
          filter={value => value}
          onAccountsSelectionChange={updateAccountsFiltered}
          placeholder="Select account"
          selectedAccounts={updateAccounts}
        />
      </Panel>
    </FilterPanel>
  );
};
